module.exports = "/_next/static/images/cheese-abeaab73f2af471a8d7a305eef6550a2.jpg";